module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_fm"
  }, [_c('p', {
    staticClass: "toc_fm"
  }, [_c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_cvi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e251"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e251"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_alb"
    }
  }, [_vm._v("Recent Titles by Glenis Wilson")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e279"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e279"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_tp"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ddeb2520e0cb0-d1e32"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "ddeb2520e0cb0-d1e32"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_cop"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e352"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e352"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_ded"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e356"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e356"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e394"
    }
  }), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e394"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_epi"
    }
  }, [_vm._v("Epigraph")])])]), _c('div', {
    staticClass: "toc_body"
  }, [_c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e403"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e403"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap001"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e431"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e431"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap002"
    }
  }, [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e583"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e583"
    }
  }), _c('a', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap003"
    }
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e847"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e847"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1069"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1069"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1284"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1284"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1443"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1443"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1595"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1595"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1670"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1670"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1921"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e1921"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e2115"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e2115"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e2345"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e2345"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e2559"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e2559"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e2769"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e2769"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e2964"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e2964"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e3202"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e3202"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e3337"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e3337"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e3471"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e3471"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e3582"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e3582"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e3877"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e3877"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e4017"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e4017"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e4247"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e4247"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e4538"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e4538"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e4720"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e4720"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e4995"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e4995"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e5214"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e5214"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e5412"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e5412"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e5568"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e5568"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e5828"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e5828"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Nine")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e5939"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e5939"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e6123"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e6123"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-One")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc_chap toc_empty"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e6299"
    }
  }), _c('p', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "dabef9d1bfb79-d1e6299"
    }
  }), _c('span', {
    staticClass: "toc-link",
    attrs: {
      "href": "#/OEBPS/9781780106403_epub_chap032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c4d489d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780106403_epub_itoc.vue
// module id = 60
// module chunks = 0